import { render, staticRenderFns } from "./boletimTurma_24.vue?vue&type=template&id=73a7b39e&"
import script from "./boletimTurma_24.vue?vue&type=script&lang=js&"
export * from "./boletimTurma_24.vue?vue&type=script&lang=js&"
import style0 from "./boletimTurma_24.vue?vue&type=style&index=0&id=73a7b39e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports